// extracted by mini-css-extract-plugin
export default {"commentsLoader":"CommentsLoader_commentsLoader__fD6dy"};